import { isNil } from 'lodash';

export function notNil<T>(value: T | null | undefined): value is T {
  return !isNil(value);
}
